import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["approveForm", "rejectForm", "approveButton", "rejectButton"]

  connect() {
    console.log("Facilitator approval controller connected")
  }

  async approve(event) {
    event.preventDefault()
    
    // Show confirmation dialog
    if (!confirm("Are you sure you want to approve this application?")) {
      return false
    }
    
    await this.submitForm(this.approveFormTarget, this.approveButtonTarget)
  }

  async reject(event) {
    event.preventDefault()
    
    // Show confirmation dialog
    if (!confirm("Are you sure you want to reject this application?")) {
      return false
    }
    
    await this.submitForm(this.rejectFormTarget, this.rejectButtonTarget)
  }

  async submitForm(form, button) {
    // Disable the button
    const originalText = button.value
    button.value = "Processing..."
    button.disabled = true
    
    // Also disable the other button to prevent double submission
    if (this.hasApproveButtonTarget) this.approveButtonTarget.disabled = true
    if (this.hasRejectButtonTarget) this.rejectButtonTarget.disabled = true
    
    const url = form.action
    const method = form.method
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content
    
    try {
      const response = await fetch(url, {
        method: method,
        headers: {
          'X-CSRF-Token': csrfToken,
          'Accept': 'text/vnd.turbo-stream.html, text/html, application/xhtml+xml',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: new FormData(form)
      })
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      
      // The Turbo Stream response will handle updating the UI
      const text = await response.text()
      if (text.includes('turbo-stream')) {
        // Let Turbo handle the stream
        Turbo.renderStreamMessage(text)
      }
    } catch (error) {
      console.error('Error processing facilitator action:', error)
      alert('An error occurred. Please try again.')
      
      // Re-enable buttons on error
      button.value = originalText
      button.disabled = false
      if (this.hasApproveButtonTarget) this.approveButtonTarget.disabled = false
      if (this.hasRejectButtonTarget) this.rejectButtonTarget.disabled = false
    }
    
    return false
  }
}